module.exports = __webpack_public_path__ + "app/img/logo-whatsapp.93bf96bb.svg";